var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHambuger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 5,
    viewBox: "0 0 20 5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#949494",
    fillRule: "evenodd",
    d: "M2.366 5C1.059 5 0 3.88 0 2.5S1.06 0 2.366 0 4.73 1.12 4.73 2.5 3.672 5 2.366 5zm15.268 0c-1.306 0-2.365-1.12-2.365-2.5S16.328 0 17.634 0C18.941 0 20 1.12 20 2.5S18.94 5 17.634 5zM10 5C8.694 5 7.634 3.88 7.634 2.5S8.694 0 10 0s2.366 1.12 2.366 2.5S11.306 5 10 5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHambuger);
export default __webpack_public_path__ + "static/media/hambuger.ca7c9c3841f1d788d30381115f857d56.svg";
export { ForwardRef as ReactComponent };